import React, {useState} from 'react';
import {TimerIcon, VisaGreenIcon} from "../../icons/icons";
import CustomButton from "../../components/UI/customButton/customButton";
import ExtensionRequestModal from "../../components/extensionRequestModal/extensionRequestModal";

const CrewDashboard = () => {
  const [openModal , setOpenModal] = useState(false)
  const handleStatus = (status) => {
    // eslint-disable-next-line default-case
    switch (status) {
      case 1 :
        return(
          "#E9FDE6"
        )
      case 2 :
        return(
          "#FFEBEB"
        )
      case 3 :
        return(
          "#E6E7E9"
        )
    }
  }
  return (
    <div className={"mt-10 bg-white p-5  grid grid-cols-2 gap-5"}>
       <div className={`shadow-lg relative h-[198px] p-5  grid justify-between rounded-lg `} style={{border:`1px solid ${handleStatus(1)}`}}>
         <div className={'absolute right-0 top-0 '}>
           <VisaGreenIcon color={`${handleStatus(2)}`}/>
         </div>
         <div className={"flex flex-col z-30"}>
           <div className={"grid grid-cols-3 mb-5"}>
             <span className={"text-xs"}>{"Visa Type"}</span>
             <div className={`text-xs flex items-center`} >
               <span className={"rounded-lg p-1"} style={{backgroundColor:`${handleStatus(2)}`}}>
                 {"Active"}
               </span>
             </div>
             <span className={"text-xs text-end"}>{"Start Date: 2024/09/18"}</span>
           </div>
           <div className={"flex justify-between"}>
             <span>{" 3-Months Residence Permit"}</span>
             <span className={"text-xs"}>{"Expire Date: 2024/12/18 "}</span>
           </div>
         </div>
         <div className={"flex justify-start items-end gap-2 z-30"}>
           <TimerIcon/>
           <div className={"flex pb-2"}>
             <div className={"flex gap-1 items-center"}>
               <span className={"text-xl text-primary-400 font-semibold"}>{"28"}</span>
               <span className={"text-gray-300"}>{"days"}</span>
               <span className={"text-xl text-primary-400 font-semibold"}>{":"}</span>
             </div>
             <div className={"flex gap-1 items-center"}>
               <span className={"text-xl text-primary-400 font-semibold"}>{"16"}</span>
               <span className={"text-gray-300"}>{"hrs"}</span>
               <span className={"text-xl text-primary-400 font-semibold"}>{":"}</span>
             </div>
             <div className={"flex gap-1 items-center"}>
               <span className={"text-xl text-primary-400 font-semibold"}>{"15"}</span>
               <span className={"text-gray-300"}>{"min"}</span>
             </div>
           </div>
         </div>
       </div>
       <div className={" flex flex-col items-center gap-5 pt-8"}>
         <div className={"text-primary-400 text-2xl font-medium"}>{"Your visa expires soon!"}</div>
         <div className={"text-gray-500"}>{"Inform your agency to extend it asap."}</div>
         <div className={"flex w-1/2 mt-5"}>
           <CustomButton onClick={() => setOpenModal(true)} styles={"px-10"} title={"Extend My Visa"} />
         </div>
       </div>
      {
        openModal &&
        <ExtensionRequestModal onClose={()=> setOpenModal(false)}/>

      }
    </div>
  );
};

export default CrewDashboard;
